import ProductPageLayout from '@/pages/products/components/ProductPageLayout';

export default function TunaPage() {
  return (
    <ProductPageLayout>
      <div className="relative">
        {/* Page background */}
        <div className="fixed inset-0 z-0 pointer-events-none">
          
        </div>

        {/* Content section */}
              <section className="relative z-10 w-full">
                  {/* Background */}
                  <div className="absolute inset-0 z-0 overflow-hidden">
                      <img
                          src="/images/k2.png"
                          alt="Slide7"
                          className="w-full h-full object-cover object-center blur-md scale-105"
                      />


                      <div className="absolute inset-0 bg-black/50"></div>
                  </div>

          <div className="relative z-10 w-full max-w-[980px] mx-auto px-6 md:px-10 py-10">
            {/* Script tagline */}
            <p className="font-script text-white text-lg md:text-xl text-center mb-4">
              America&#39;s One-Stop-Shop for Seafood
            </p>

            {/* H1 + Header Image */}
            <div className="flex flex-col md:flex-row items-start justify-between gap-4 md:gap-8 mb-2">
              <h1 className="font-heading text-white text-5xl md:text-6xl lg:text-7xl tracking-[0.2em] leading-none uppercase">
                Wholesale<br />TUNA
              </h1>
              <div className="flex-shrink-0">
                <img
                                  src="/images/po8.png"
                  alt="Tuna Header"
                  className="w-[615px] max-w-full h-auto"
                />
              </div>
            </div>

            {/* Subheading */}
            <h5 className="font-heading text-white text-lg md:text-xl tracking-[0.15em] leading-snug mb-6 uppercase">
              Wholesale Tuna<br />from Finest Kind Seafood LLC
            </h5>

            {/* First paragraph - font_7 equivalent */}
            <p className="text-white text-sm leading-relaxed mb-6">
              Another premier product of ours, FKS specializes in both Yellowfin and Bigeye tuna, maintaining a steady supply of both throughout the year. These tunas are caught both as a by-catch and as a targeted species. Our wholesale tunas are immediately bled and iced on board, ensuring they retain peak freshness.
            </p>

            {/* Paragraph 2 with zoom image floated */}
            <div className="relative">
              <img
                              src="/images/po9.png"
                alt="Wholesale Tuna Zoom"
                className="float-right ml-6 mb-4 w-[280px] md:w-[378px] h-auto"
              />
              <p className="text-white text-[13px] leading-relaxed mb-5">
                Tunas are large pelagic fish that can be found in oceans across the globe. Pelagic fish refers to a category of fish grouped together by the area of the ocean they inhabit, which is deeper waters. At Finest Kind Seafood LLC, we offer our fresh, wholesale tuna as H&amp;G (headed &amp; gutted), loins, steaks, and custom portions. Like our swordfish – and nearly all our other products – we aim to purchase our fresh tuna locally as often as possible. Tuna fishing in the western North Atlantic is best in the summer, when the fish are actively feeding and the oil content is highest. However, due to weather conditions and government regulated time frames for fishing zones, we also purchase our wholesale tuna from fishermen in Hawaii, the Caribbean, and Latin America, Australia, and multiple other locations throughout the year, depending on the seasons.
              </p>
              <div className="clear-both" />
            </div>

            {/* Paragraph 3 */}
            <p className="text-white text-[13px] leading-relaxed mb-5">
              Finest Kind Seafood LLC has held long lasting, personal relationships with long liner fisherman both locally and from around the world for sourcing our tuna. Long line fishing is a relatively new concept as of the 1950&#39;s when the fisherman from Japan started to spread the concept. The art of long line fishing has now spread across the world and is most notably used by fisherman in the United States and other South Pacific nations. The importance of long line fishing has become more and more apparent as new environmental data emerges. While some wholesalers still use un-ethical netting tactics, our partners choose to fish with long liners.
            </p>

            {/* Paragraph 4 */}
            <p className="text-white text-[13px] leading-relaxed mb-10">
              The grading scale for tuna is unique due to the heavy market demand for sashimi and sushi grade tuna. Tuna is graded based on color and fat content in both a tail cut and a bloodline poke. In that respect, tuna graded as &#34;#1&#34; refers to sushi grade tuna containing beautiful color and high fat content. The best tuna will have a bloodline that glows as though it were fresh blood. Next, &#34;2+&#34; tunas contain slightly reduced color quality and fat content; &#34;2G&#34; refers to grades too good to be a &#34;2&#34; but on the lesser end of a &#34;2+&#34; grade; and &#34;#2&#39;s&#34; refer to grill grade tuna.
            </p>
          </div>
        </section>
      </div>
    </ProductPageLayout>
  );
}